import { render, staticRenderFns } from "./HandwritingInput1Char.vue?vue&type=template&id=95ad643a&scoped=true&"
import script from "./HandwritingInput1Char.vue?vue&type=script&lang=js&"
export * from "./HandwritingInput1Char.vue?vue&type=script&lang=js&"
import style0 from "./HandwritingInput1Char.vue?vue&type=style&index=0&id=95ad643a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ad643a",
  null
  
)

export default component.exports